const u = (e) => Object.keys(e).reduce((r, c) => {
  const t = e[c];
  return r + Object.keys(t).reduce((n, o) => {
    const s = t[o];
    return `${n} --color-${c}-${o}: ${s};`;
  }, "");
}, "");
function f(...e) {
  const r = {};
  return e.forEach((c) => {
    Object.entries(c).forEach(([t, n]) => {
      i(n) && i(r[t]) ? r[t] = f(r[t], n) : Array.isArray(n) && Array.isArray(r[t]) ? r[t] = [...r[t], ...n] : r[t] = n;
    });
  }), r;
}
function i(e) {
  return e != null && typeof e == "object" && !Array.isArray(e);
}
function $(e, r) {
  return (e == null ? void 0 : e.map((c) => {
    const {
      fontFamily: t,
      fontStyle: n,
      fontWeight: o,
      src: s
    } = c;
    return `
          @font-face {
            font-family: ${t};
            font-style: ${n};
            font-weight: ${o};
            src: ${r ? s.replace("/publicUrl", r) : s.replace("/publicUrl", "")};
          }
        `;
  }).join("")) || "";
}
const l = (e, r) => Object.keys(r).reduce((c, t) => {
  const n = r[t];
  return `${c} --${e}-${t}: ${n};`;
}, "");
export {
  u as colorToCSSVariables,
  f as deepMerge,
  $ as getFontFaces,
  l as objectToCSSVariables
};
//# sourceMappingURL=utils.es.js.map
